import type { IconSvgObject } from './types';

const ThumbsUpEllipseIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.1127 16.5H9C8.44772 16.5 8 16.0523 8 15.5V10.8508C8 10.6237 8.07728 10.4034 8.21913 10.2261L12 5.5L12.1138 5.58535C13.2208 6.41559 13.6163 7.89526 13.0712 9.16711L12.5 10.5H16.571C17.2653 10.5 17.7484 11.1902 17.5105 11.8425L16.0522 15.8425C15.9083 16.2373 15.5329 16.5 15.1127 16.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ThumbsUpEllipseIcon;
